import DoubleChanceButton from './DoubleChanceButton'
import { useConfigurationStore } from '@stores'

const DoubleChance = () => {
    const hasDoubleChance = useConfigurationStore((s) => s.hasDoubleChance)

    return (
        <>
            {hasDoubleChance && (
                <>
                    <DoubleChanceButton />
                </>
            )}
        </>
    )
}

export default DoubleChance
